import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 42.625 42.625">
  <path d="M22-37.812A21.316,21.316,0,0,0,.688-16.5,21.311,21.311,0,0,0,22,4.813,21.311,21.311,0,0,0,43.313-16.5,21.316,21.316,0,0,0,22-37.812Zm0,9.453a3.609,3.609,0,0,1,3.609,3.609A3.609,3.609,0,0,1,22-21.141a3.609,3.609,0,0,1-3.609-3.609A3.609,3.609,0,0,1,22-28.359ZM26.813-6.531A1.031,1.031,0,0,1,25.781-5.5H18.219a1.031,1.031,0,0,1-1.031-1.031V-8.594a1.031,1.031,0,0,1,1.031-1.031H19.25v-5.5H18.219a1.031,1.031,0,0,1-1.031-1.031v-2.062a1.031,1.031,0,0,1,1.031-1.031h5.5a1.031,1.031,0,0,1,1.031,1.031v8.594h1.031a1.031,1.031,0,0,1,1.031,1.031Z" transform="translate(-0.688 37.813)"/>
</svg>
  )
